import { Skeleton, LoadingState } from '../common/Skeleton';
import { SplitRow } from '../common/SplitRow';
import { CommandStrip } from './CommandStrip';

// First-load placeholder for the Daily dashboard. Shown only on cold load: once
// data has landed the hooks hold-until-ready, so day-stepping never returns
// here.
//
// IT IS BUILT FROM THE PAGE'S OWN CONTAINERS, not from blocks arranged to look
// roughly like it. Every wrapper below — `today-desk`, `desk-section`,
// `desk-section-head`, `desk-list`, `today-chart`, and the `SplitRow` toolbar —
// is the same element the loaded page uses, so the gaps, padding and column
// widths are correct by construction rather than by a second set of numbers
// kept in step by hand. Only the leaves are placeholders.
//
// A skeleton that reserves the wrong space is worse than none: it promises a
// layout and then withdraws it.
export function TodaySkeleton() {
  const section = (key: string) => (
    <div className="today-section desk-section" key={key}>
      {/* The head carries a title and a done-count on the real page; one line
          holds its 24px so the list below starts where it will start. */}
      <div className="desk-section-head">
        <Skeleton variant="line" />
      </div>
      {/* The REAL list container, so the 6px between rows is the page's own —
          the rows read as separate cards rather than one continuous slab. */}
      <div className="desk-list">
        <Skeleton variant="row" />
        <Skeleton variant="row" />
        <Skeleton variant="row" />
      </div>
    </div>
  );

  return (
    <LoadingState label="Loading today…" className="today-view today-loading">
      {/* THE REAL STRIP, in its loading state — not a placeholder shaped like
          it. Its own skeletons are sized to the elements they stand in for, so
          every segment measures the same loading as loaded and the rail does
          not resize under the cursor when the data arrives. A separate
          placeholder would be a second thing to keep in step with the first. */}
      <CommandStrip
        attention={[]}
        am={[]}
        pm={[]}
        residenceCount={0}
        loading
        open={null}
        onOpen={() => {}}
        panels={{ attention: null, duty: null, residence: null }}
      />

      <div className="today-desk">
        {section('drop-offs')}
        {section('collections')}
      </div>

      {/* THE CHART IS PART OF THE PAGE, so it is part of the placeholder. It was
          missing, which meant the skeleton described a page ending at the desk
          and then a chart's worth of height arrived beneath it the moment the
          bookings landed. Its toolbar is reserved through the same SplitRow the
          real one is drawn with. */}
      <div className="today-chart">
        <SplitRow right={<Skeleton variant="line" />} />
        <Skeleton variant="chart" />
      </div>
    </LoadingState>
  );
}
